import moment from "moment-timezone";
import { Row, Col, Grid } from "antd";

import { RAInputTimePickerMobile } from "@/components/atoms";
import { SvgCalendar, SvgTime } from "@/assets/icons";
import { RADatePicker } from "@/components/customs";
import dayjs from "dayjs";

const { useBreakpoint } = Grid;

export function InputDepartureDate({
	formValues = {},
	onChange,
	error = {},
	disabledFromDate,
	prevLegDate = null,
	legIndex = 0,
}) {
	const screens = useBreakpoint();

	const { departure_datetime } = formValues;

	if (!screens.xs) {
		return (
			<Row gutter={0}>
				<Col span={24}>
					<RADatePicker
						prefix={<SvgCalendar color="#595959" />}
						placeholder="Departure date"
						value={departure_datetime || null}
						showTime
						disabledFromDate={disabledFromDate}
						onSelect={(val) => {
							let value = val;
							if (!departure_datetime) {
								value = moment(val).set({ hour: 12, minute: 0 }).toISOString();
							}
							onChange({
								...formValues,
								departure_datetime: value,
							});
						}}
						error={error?.departure_datetime}
						defaultPickerValue={prevLegDate ? dayjs(prevLegDate, "YYYY-MM") : null}
						data-testid={`flightLeg_departureDate_${legIndex}`}
					/>
				</Col>
			</Row>
		);
	}
	// mobile view: date + time
	return (
		<Row gutter={[8, 12]}>
			<Col span={12}>
				<RADatePicker
					prefix={<SvgCalendar color="#595959" />}
					placeholder="Date"
					value={departure_datetime || null}
					disabledFromDate={disabledFromDate}
					format="ddd, MMM DD"
					onChange={(val) => {
						let value = val;
						if (!departure_datetime) {
							value = moment(val).set({ hour: 12, minute: 0 }).toISOString();
						}
						onChange({
							...formValues,
							departure_datetime: value,
						});
					}}
					error={error?.departure_datetime}
					defaultPickerValue={prevLegDate ? dayjs(prevLegDate, "YYYY-MM") : null}
				/>
			</Col>
			<Col span={12}>
				<RAInputTimePickerMobile
					prefix={<SvgTime color="#595959" />}
					placeholder="Time"
					value={departure_datetime || null}
					disabledFromDate={disabledFromDate}
					onChange={(val) => {
						let date = departure_datetime ? moment(departure_datetime) : moment();
						let time = moment(val);
						date = moment(date).set({
							hour: time.get("hour"),
							minute: time.get("minute"),
						});
						onChange({
							...formValues,
							departure_datetime: date.toISOString(),
						});
					}}
				/>
			</Col>
		</Row>
	);
}
